export function initAgendaLinks() {
  const agendaLinks = document.querySelectorAll(".agenda p a");

  agendaLinks.forEach(link => {
    link.setAttribute("target", "_blank");
    link.setAttribute("rel", "noopener noreferrer");
  });
}